import { render } from "./PagoCliente.vue?vue&type=template&id=8039e2f4&scoped=true"
import script from "./PagoCliente.vue?vue&type=script&lang=js"
export * from "./PagoCliente.vue?vue&type=script&lang=js"

import "./PagoCliente.vue?vue&type=style&index=0&id=8039e2f4&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8039e2f4"]])

export default __exports__